// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"6b9ba151","195":"b29d6939","326":"2417f166","383":"2ea830d7","641":"5b50cf19"}[chunkId] + ".chunk.css";
};